import { render } from "./FpAside.vue?vue&type=template&id=6de6997f&lang=pug"
import script from "./FpAside.vue?vue&type=script&lang=js"
export * from "./FpAside.vue?vue&type=script&lang=js"

import "./FpAside.vue?vue&type=style&index=0&id=6de6997f&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__